module.exports = __webpack_public_path__ + "static/media/Social_elIg_circle_65880.c8efbda5.png";